var _jsxFileName = "E:\\githup\\dxc-flex\\src\\Block.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/** @jsx jsx */
import React from "react";
import { jsx } from "@emotion/react";

var Block = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Block, _React$PureComponent);

  function Block() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = Block.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        _this$props$layout = _this$props.layout,
        layout = _this$props$layout === void 0 ? "horizontal" : _this$props$layout,
        horizontal = _this$props.horizontal,
        vertical = _this$props.vertical,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "layout", "horizontal", "vertical"]);

    var css = {};

    if (layout === "horizontal") {
      css.display = "flex";
      css.flexFlow = "row";
    } else if (layout === "vertical") {
      css.display = "flex";
      css.flexFlow = "column";
    } else if (layout === "flow") {
      css.display = "flex";
      css.flexFlow = "wrap";
    }

    var justify, align;

    if (layout === "horizontal" || layout === "flow") {
      justify = horizontal;
      align = vertical;
    } else if (layout === "vertical") {
      justify = vertical;
      align = horizontal;
    }

    switch (justify) {
      case "start":
        css.justifyContent = "flex-start";
        break;

      case "center":
        css.justifyContent = "center";
        break;

      case "end":
        css.justifyContent = "flex-end";
        break;

      case "around":
        css.justifyContent = "space-around";
        break;

      case "between":
        css.justifyContent = "space-between";
        break;

      default:
    }

    switch (align) {
      case "start":
        css.alignItems = "flex-start";
        break;

      case "center":
        css.alignItems = "center";
        break;

      case "end":
        css.alignItems = "flex-end";
        break;

      default:
    }

    return jsx("div", _extends({
      css: css
    }, props, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 58,
        columnNumber: 7
      }
    }), children);
  };

  return Block;
}(React.PureComponent);

export default Block;